import React, { useState } from "react";
import PropTypes from "prop-types";
import "!style-loader!css-loader!../styles.css";

import {
  FormGroup,
  FormControl,
  FormLabel,
  Form,
  Button,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";

const ForgotForm = (props) => {
  const { returnToEmail, onResetPassword, emailAddress } = props;

  const [resetEmailValidated, setResetEmailValidated] = useState(false);
  const [resetEmail, setResetEmail] = useState(emailAddress || "");

  const handleEmailInput = (e) => {
    setResetEmail(e.target.value);
  };

  const checkEmailValid = () => {
    const emailSplit = resetEmail.split("@");
    return (
      typeof emailSplit[0] === "string" &&
      emailSplit[0].length > 0 &&
      typeof emailSplit[1] === "string" &&
      emailSplit[1].length > 0
    );
  };

  const handleSubmitResetEmail = (e) => {
    e.preventDefault();
    const form = e.target;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setResetEmailValidated(true);
    } else {
      onResetPassword(resetEmail, "reset");
      returnToEmail();
    }
  };

  return (
    <>
      <h5 className="mb-4" style={{ color: "#000", fontSize: "28px" }}>
        Forgot your password?
      </h5>
      <p className="mb-4" style={{ fontSize: "16px" }}>
        Enter your email address below to receive an email containing a link to
        reset your password.
      </p>
      <Form
        noValidate
        validated={resetEmailValidated}
        onSubmit={handleSubmitResetEmail}
      >
        <FormGroup className="mb-4">
          {resetEmailValidated && !checkEmailValid() && (
            <div
              style={{
                borderRadius: "3px",
                backgroundColor: "#fbe8eb",
                color: "#e11f3b",
                height: "50px",
                width: "100%",
                marginBottom: "10px",
                textAlign: "left",
                paddingLeft: "7px",
                lineHeight: "50px",
                fontSize: "16px",
              }}
            >
              <FontAwesome name="exclamation-triangle" /> Please enter a valid
              email address.
            </div>
          )}
          <FormLabel
            className="font-weight-bold"
            style={{ fontSize: "14px", marginBottom: "2px" }}
          >
            Email Address
          </FormLabel>
          <FormControl
            type="email"
            placeholder="Enter your email here"
            id="resetEmail"
            value={resetEmail}
            onChange={handleEmailInput}
            data-test="email"
            required
          />
        </FormGroup>
        <div className="text-center mb-4">
          <Button
            type="submit"
            variant="primary"
            size="lg"
            id="submitEmail"
            className="font-weight-bold"
            style={{ width: "100%", fontSize: "14px" }}
            disabled={resetEmail.length < 1}
          >
            Email Password Reset Link
          </Button>
        </div>
        <div className="text-center">
          <button
            type="button"
            className="btn-as-link-no-state font-weight-bold"
            onClick={returnToEmail}
            id="returnToEmail"
            style={{ fontSize: "14px" }}
          >
            Back to log in
          </button>
        </div>
      </Form>
    </>
  );
};

ForgotForm.propTypes = {
  returnToEmail: PropTypes.func,
  onResetPassword: PropTypes.func,
  emailAddress: PropTypes.string,
};

export default ForgotForm;
